import React, {Component} from 'react';
import PlayersQuantity from './players-quantity';
import StackTeamsExposure from './stack-teams-exposure';
import StackTeams from './stack-teams';
import StackTeamsChecking from './stack-teams-checking';

class StackOptions extends Component {
    render() {
        return (
            <div className="team-stack mlb-stack mw-none">
                <div className="form-row-new">
                    <div className="form-inline">
                        <strong className="form-text">Stack</strong>
                        <PlayersQuantity groupNumber={1} />
                        <strong className="form-text">players with</strong>
                        <PlayersQuantity groupNumber={2} />
                        <strong className="form-text">players</strong>
                    </div>
                    <div className="form-inline justify-content-end">
                        <strong className="form-text">Team exposures:</strong>
                        <StackTeamsExposure />
                    </div>
                </div>
                <div className="chk-all-stack">
                    <div className="checkbox">
                        <StackTeamsChecking />
                    </div>
                </div>
                <div className="stack-container">
                    <StackTeams />
                </div>
            </div>
        );
    }
}

export default StackOptions;
